module.exports = __webpack_public_path__ + "img/bus-school.ab7b79db.png";